import React from 'react';
import { PaginationOutput } from 'js/model/rainbow/PaginationOutput';
import { Pagination } from 'js/components/Pagination/Pagination';
import {
  changeBrowseDataContext,
  ChangeBrowseDataFunction,
  AddLocation,
} from '../BrowseData';

interface Props {
  pagination: PaginationOutput;
  createPageUri: (page: number) => string;
}

export class BrowsePagination extends React.PureComponent<Props> {
  public static contextType = changeBrowseDataContext;

  private onPageChange = (page: number): void => {
    const changeBrowseData = this.context as ChangeBrowseDataFunction;
    changeBrowseData({ page }, undefined, AddLocation.CurrentPageWithRadius);
  };

  public render(): React.ReactNode {
    return <Pagination {...this.props} onPageChange={this.onPageChange} />;
  }
}
